import { Component } from '@angular/core';
import { SelectLineProductsGet, SelectLineProductsParams } from '../select-line-products.component';
import { StateService } from '@app/core/services/state.service';
import { ProductsConfigParams } from '../../products-config/products-config.component';

@Component({
    selector: 'tt-select-line-products-view',
    templateUrl: './select-line-products-view.component.html',
    styleUrls: ['./select-line-products-view.component.css'],
})
export class SelectLineProductsViewComponent {
    heading = '';

    params: SelectLineProductsParams;

    constructor(private state: StateService) {
        this.params = this.state.getStateParams() as unknown as SelectLineProductsParams;
    }

    public setHeading(event: SelectLineProductsGet) {
        this.heading = event.webpage_heading;
    }

    public onSubmit(event: ProductsConfigParams) {
        this.state.go('productsconfig', event);
    }
}
